export default {
  setInputerData(state, { payload }) {
    state.allInputerData = payload;
  },
  setApprover1Data(state, { payload }) {
    state.allApprover1Data = payload;
  },
  setApprover2Data(state, { payload }) {
    state.allApprover2Data = payload;
  },
  setLoadingApprover1(state, payload) {
    state.loadingApprover1 = payload;
  },
  setLoadingApprover2(state, payload) {
    state.loadingApprover2 = payload;
  },
  setLoadingInputer(state, payload) {
    state.loadingInputer = payload;
  },
  setMerchants(state, { payload }) {
    state.allMerchants = payload.data.list;
  },

  setFlashErrorMessage(state, payload) {
    state.flashErrorMessage = payload;
    state.flashError = payload !== '';
  },

  clearMerchants(state) {
    state.allMerchants = [];
    state.totalMerchants = 0;
  },

  clearErrors(state) {
    state.errors = [];
  },

  setErrors(state, payload) {
    state.errors = payload;
  },

  setTotalMerchants(state, { payload }) {
    state.totalMerchants = parseInt(payload.data.countdata, 10);
    state.totalPage = parseInt(payload.data.totalPage, 10);
  },

  setLoading(state, loading) {
    state.loading = loading;
  },

  setLoadingPic(state, payload) {
    state.loadingDataPic = payload;
  },

  setDetailMerchant(state, { payload }) {
    state.merchant = payload;
  },

  setStateVariable(state, { payload, variable }) {
    state[variable] = payload;
  },

  setIntervalSwitch(state, payload) {
    state.intervalSwitch = payload;
  },

  setSwitchData(state, payload) {
    state.switchId = payload.export_id;
    state.countDataSwitch = parseInt(payload.count_data, 10);
  },
  setSwitchStatus(state, status) {
    state.switchStatus = status;
  },
  setPercentage(state, value) {
    state.percentage = value;
  },
  setShowProgressBar(state, status) {
    state.showProgressBar = status;
  },
  setProgressTitle(state, title) {
    state.progressTitle = title;
  },
  setProgressColor(state, color) {
    state.progressColor = color;
  },
  setIntervalInsert(state, interval) {
    state.intervalInsert = interval;
  },
};